import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  AutoForecastSettingDetailItemApi,
  CreateAutoForecastSettingDetailItemBody,
  CreateMultiAutoForecastSettingDetailItemBody,
  FindEntityPolicyForUpdate,
  UpdateAutoForecastSettingDetailItemBody,
} from 'api';

export const createAutoForecastSettingDetailItem = createAsyncThunk(
  'autoForecastSettingDetailItem/createAutoForecastSettingDetailItem',
  async (
    body: CreateAutoForecastSettingDetailItemBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastSettingDetailItemApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiAutoForecastSettingDetailItem = createAsyncThunk(
  'autoForecastSettingDetailItem/createMultiAutoForecastSettingDetailItem',
  async (
    body: CreateMultiAutoForecastSettingDetailItemBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastSettingDetailItemApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAutoForecastSettingDetailItem = createAsyncThunk(
  'autoForecastSettingDetailItem/updateAutoForecastSettingDetailItem',
  async (
    params: { id: string; body: UpdateAutoForecastSettingDetailItemBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await AutoForecastSettingDetailItemApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAutoForecastSettingDetailItem = createAsyncThunk<
  any,
  string,
  { rejectValue: { message: string } }
>(
  'autoForecastSettingDetailItem/deleteAutoForecastSettingDetailItem',
  async (id, { rejectWithValue }) => {
    try {
      const response = await AutoForecastSettingDetailItemApi.delete(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityProposalPolicyForUpdateAutoForecastSettingDetailItem =
  createAsyncThunk(
    'autoForecastSettingDetailItem/findEntityProposalPolicyForUpdateAutoForecastSettingDetailItem',
    async (option: FindEntityPolicyForUpdate, { rejectWithValue }) => {
      try {
        const response =
          await AutoForecastSettingDetailItemApi.findEntityProposalPolicyForUpdate(
            option
          );
        return response;
      } catch (error: any) {
        if (!error.response) {
          throw error;
        }

        return rejectWithValue(error.response.data);
      }
    }
  );

interface InitialState {
  data: any | undefined;
}

const initialState: InitialState = {
  data: undefined,
};

const autoForecastSettingDetailItemSlice = createSlice({
  name: 'autoForecastSettingDetailItem',
  initialState,
  reducers: {},
});

const { reducer: AutoForecastSettingDetailItemReducer } =
  autoForecastSettingDetailItemSlice;

export default AutoForecastSettingDetailItemReducer;
